module.exports = __webpack_public_path__ + "62370f5f3449c068892c408d3c403ba4.jpg";